import { render, staticRenderFns } from "./Comanda.vue?vue&type=template&id=d1886152&scoped=true"
import script from "./Comanda.vue?vue&type=script&lang=js"
export * from "./Comanda.vue?vue&type=script&lang=js"
import style0 from "./Comanda.vue?vue&type=style&index=0&id=d1886152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1886152",
  null
  
)

export default component.exports